// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-row[data-v-e643e514]{min-height:100%}.box-container[data-v-e643e514]{height:100vh;display:grid;align-items:center;justify-items:center;place-items:center}.box[data-v-e643e514]{width:85vw;box-shadow:0 5px 5px #ccc;border:1px solid #eee;padding:1rem;text-align:center}options[data-v-e643e514]{display:flex;flex-flow:column}b-button[data-v-e643e514]{margin:.5rem}@media only screen and (min-width:768px){.box[data-v-e643e514]{width:35vw}}", ""]);
// Exports
module.exports = exports;
